import { patchRequest } from 'js/helpers/apiClient';
import { useMutationWithLogout } from 'js/hooks/useMutationWithLogout';
import apiRoutes from '../../../api-routes';

export const useCategoryUpdate = (options) =>
  useMutationWithLogout(async ({ id, data }) => {
    const { data: updateData } = await patchRequest({
      url: apiRoutes.SINGLE_CATEGORY.replace('{id}', id),
      data,
      headers: {
        Authorization: sessionStorage.getItem('token'),
      },
    });

    return updateData;
  }, options);
